export default "__VITE_PUBLIC_ASSET__ce3442cf__"